export default "__VITE_ASSET__CbMdnF$S__"